import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

import {YouAreHereComponent} from './you-are-here.component';

@NgModule({
  declarations: [YouAreHereComponent],
  exports:      [YouAreHereComponent],
  imports:      [CommonModule, NgbTooltipModule]
})
export class YouAreHereModule {}
